// Takes a single string containing the content for a disabled login message
// The content is expected to have new lines separating different blocks of text
// The first block is treated as the title, and the rest as paragraphs
// Returns an object with a title and an array of paragraphs
export function parseDisabledLoginContent(content: string): { title: string; paragraphs: string[] } {
  const blocks: string[] = [];
  let currentBlock: string[] = [];

  if (!content) {
    return { title: "", paragraphs: [] };
  }

  content
    .split("\n")
    .map(line => line.trim())
    .forEach(line => {
      if (line === "") {
        if (currentBlock.length > 0) {
          blocks.push(currentBlock.join(" ").trim());
          currentBlock = [];
        }
      } else {
        currentBlock.push(line);
      }
    });

  if (currentBlock.length > 0) {
    blocks.push(currentBlock.join(" ").trim());
  }

  const title = blocks[0] || "";
  const paragraphs = blocks.slice(1);

  return { title, paragraphs };
}
